import { useContext } from 'react'
import get from 'lodash/get'

import { FnaContext } from '../../../context'
import { ASSESSMENT_TYPE } from '../../../reducer'
import { sumSelectedRiskProducts } from '../../../utils'

export const buildInitialValues = () => {
  const {
    state: {
      fna: {
        [ASSESSMENT_TYPE.INCOME_PROTECTION]: assessment
      },
      riskProducts,
    }
  } = useContext(FnaContext)

  const assetables_attributes = get(assessment, 'assetables', [])
  const risk_productables_attributes = get(assessment, 'risk_productables', [])

  return {
    existing_cover: get(assessment, 'existing_cover', 0),
    monthly_budget_expenses: get(assessment, 'monthly_budget_expenses', 0),
    total_asset_monthly_contributions: get(assessment, 'total_asset_monthly_contributions', 0),
    total_monthly_expenses: get(assessment, 'total_monthly_expenses', 0),
    total_from_selected_risk_products: sumSelectedRiskProducts(riskProducts, risk_productables_attributes),
    risk_productables_attributes,
    assetables_attributes,
  }
}
